// src/utils/languageUtils.js

/**
 * Helper to get data from an object based on language.
 * Handles both database fields (name_en, name_uz) and object maps ({en: "X", uz: "Y"}).
 */
export const getLocalized = (data, lang, field = null) => {
    if (!data) return "";

    // Case 1: Data is a simple string (no translation needed)
    if (typeof data === 'string') return data;

    // Case 2: Data is an object like { en: "Apple", uz: "Olma" }
    // We check if the specific language key exists directly on data
    if (data[lang]) {
        return data[lang];
    }
    
    // Case 3: We are looking for a field inside an object (e.g. product.tree)
    // and expecting keys like name_en, name_uz
    if (field) {
        const specificKey = `${field}_${lang}`; // e.g. name_uz
        if (data[specificKey]) {
            return data[specificKey];
        }
        // Fallback to English field
        if (data[`${field}_en`]) {
            return data[`${field}_en`];
        }
        // Fallback to raw field
        if (data[field]) {
            return data[field];
        }
    }

    // Case 4: Fallback for object map (Case 2) if exact lang missing
    if (data['en']) return data['en'];

    return "";
};